import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import HubIcon from "@mui/icons-material/Hub";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import InsightsIcon from "@mui/icons-material/Insights";
import RadarIcon from "@mui/icons-material/Radar";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { appTheme } from "../../../shared/theme";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const team = [
  {
    name: "Rachel",
    role: "Head of Development",
    text: "Builds the vision and ensures every detail delivers.",
    icon: <RocketLaunchIcon sx={{ fontSize: 22 }} />,
    accent: "rgba(92,181,179,0.16)",
    image: "/imgs/Team/Rachel.png",
    linkedin: "https://www.linkedin.com/in/rachel-beck-a0324b227/",
    profileSummary: {
      whatTheyDo:
        "A mix of building, leading, and keeping everything moving. I oversee development, marketing, customer experience, and documentation...and i also code.",
      whatTheyBring:
        "Big-picture thinking, sharp attention to detail, and the ability to turn moving parts into a clear plan.",
      timeAtCompany: "Here since day 1, Est. January 2023",
    },
    answers: {
      whatDoYouDo:
        "A mix of building, leading, and keeping everything moving. I oversee development, marketing, customer experience, and documentation...and i also code.",
      weekendPlan:
        "Family time, good food, and usually something creative or outdoors.",
      destination: "Japan",
      setsApart:
        "It’s one of those things where once you use it, you realise how much time you were wasting before. Everything’s in one place, and it just works for both hosts and guests.",
      hiddenTalent: "Good at turning chaos into a plan.",
      loveAboutTeam:
        "Everyone genuinely cares about what we’re building and pushes for better.",
      catOrDog: "Dogs",
      earlyOrNight: "Night owl",
      coffee: "Hot Chocolate",
      beachOrMountains: "Beach",
    },
  },
  {
    name: "Dorna",
    role: "Technical Team Lead",
    text: "Leads the technology and solves complex challenges to keep everything running smoothly.",
    icon: <HubIcon sx={{ fontSize: 22 }} />,
    accent: "rgba(92,181,179,0.16)",
    image: "/imgs/Team/Dorna.png",
    linkedin: "https://www.linkedin.com/in/dorna-hassani-01aa9327/",

    profileSummary: {
      whatTheyDo:
        "Leads the technical direction of the platform and supports the team in building scalable, reliable solutions.",
      whatTheyBring:
        "Technical depth, calm problem solving, and a strong focus on quality and stability.",
      timeAtCompany: "Joined the crew April 2023",
    },
    answers: {
      whatDoYouDo:
        "I help turn ideas into reality. Working closely with the team to design and build the platform, solve tricky problems, and make sure everything runs smoothly behind the scenes so our users have a seamless experience.",
      weekendPlan:
        "A mix of good coffee, time outdoors, and something a bit different. Whether it’s exploring a new spot, catching up with friends, or diving into a side project.",
      destination: "The U.S. to see my nephew",
      setsApart:
        "We’re not just offering perks. We’re rethinking how people experience work and life. 7DAY connects businesses with meaningful, flexible experiences that people find valuable, which makes a real impact on culture, not just checkboxes.",
      hiddenTalent:
        "I enjoy breaking down complex problems into simple, practical solutions. Whether it’s in code or everyday life.",
      loveAboutTeam:
        "The balance of ambition and collaboration. Everyone genuinely cares about what we’re building, and there’s a strong sense of ownership without ego, which makes it a great environment to do meaningful work.",
      catOrDog: "Dogs",
      earlyOrNight: "Early bird",
      coffee: "Almond Cap",
      beachOrMountains: "Mountains",
    },
  },
  {
    name: "Zad",
    role: "Full Stack Developer",
    text: "Builds across the stack, combining scalable technology and AI to bring ideas to life.",
    icon: <PsychologyAltIcon sx={{ fontSize: 22 }} />,
    accent: "rgba(92,181,179,0.16)",
    image: "/imgs/Team/Zad.png",
    linkedin: "https://www.linkedin.com/in/zadsharafi/",
    profileSummary: {
      whatTheyDo:
        "Builds features across the platform and explores how AI can be used in practical, useful ways.",
      whatTheyBring:
        "Curiosity, innovation, and a smart approach to solving technical challenges.",
      timeAtCompany: "Joined the crew March 2024",
    },
    answers: {
      whatDoYouDo:
        "I help build new features and improve the ones we already have!",
      weekendPlan: "Finishing a whole mini-series in one sitting",
      destination: "Dubai",
      setsApart:
        "It’s more than just a booking app. we’re building experiences.",
      hiddenTalent:
        "Fixing electronics by turning them off and turning them back on",
      loveAboutTeam:
        "They’re smart and genuinely friendly. everyone brings something valuable.",
      catOrDog: "Cat",
      earlyOrNight: "Night owl",
      coffee: "Almond latte, no sugar",
      beachOrMountains: "Mountains",
    },
  },
  {
    name: "Tom",
    role: "Full Stack Developer",
    text: "Builds across the stack with precision, creating detail-driven features & location-aware systems.",
    icon: <RadarIcon sx={{ fontSize: 22 }} />,
    accent: "rgba(92,181,179,0.16)",
    image: "/imgs/Team/Tom.png",
    linkedin: "https://www.linkedin.com/in/thomas-dickson-6a4a0a229/",
    profileSummary: {
      whatTheyDo:
        "Builds and refines platform features with a strong focus on technical precision and real-world use.",
      whatTheyBring:
        "Accuracy, consistency, and a thoughtful approach to detail-driven systems.",
      timeAtCompany: "Joined the crew March 2024",
    },
    answers: {
      whatDoYouDo:
        "As a software engineer at 7DAY, I transform ideas into an engaging platform for our users",
      weekendPlan: "Video games with my partner",
      destination: "Gold Coast theme parks",
      setsApart:
        "7DAY is a unique product which bridges the gap between work and play. It allows companies to easily organise experiences for their employees to enjoy, all in one place",
      hiddenTalent: "Guitar",
      loveAboutTeam:
        "I love how collaborative the 7DAY team is. The team encourages learning and sharing knowledge, and has allowed me to grow significantly as a developer.",
      catOrDog: "Dogs",
      earlyOrNight: "Night Owl",
      coffee:
        "Cold Brew. One of my favourite perks of the 7DAY office is the free iced coffee in the fridge.",
      beachOrMountains:
        "I prefer the mountains. Working at 7DAY allows me the freedom to work remotely from Wollongong, so I’m surrounded by both mountains and beaches.",
    },
  },
  {
    name: "Colin",
    role: "UX/UI Designer",
    text: "Designs intuitive experiences, turning complex flows into something simple and seamless.",
    icon: <DesignServicesIcon sx={{ fontSize: 22 }} />,
    accent: "rgba(92,181,179,0.16)",
    image: "/imgs/Team/Colin.png",
    linkedin: "https://www.linkedin.com/in/colin-watson-b3845484/",
    profileSummary: {
      whatTheyDo:
        "Designs the product experience so the platform feels intuitive, polished, and easy to use.",
      whatTheyBring:
        "Creative thinking, user-focused design, and a strong eye for the details that shape great UX.",
      timeAtCompany: "Joined the crew October 2025",
    },
    answers: {
      whatDoYouDo: "Making things easy and pleasant to use.",
      weekendPlan:
        "Catching up with friends for coffee; fussing over my dough prep.",
      destination: "Osaka",
      setsApart:
        "Remembering to live (memento vivere). Appreciating the time you have.",
      hiddenTalent:
        "Teaching people how to ride motorcycles safely on the roads.",
      loveAboutTeam:
        "We trust each other; and everyone’s accepting, open, and big-hearted.",
      catOrDog: "Dogs",
      earlyOrNight: "Early bird",
      coffee:
        "Espresso shot (for taste); long black with big breakfast; strong flat white with a croissant.",
      beachOrMountains: "Mountains in the day, beach at night.",
    },
  },
  // {
  //   name: "James",
  //   role: "Product Specialist",
  //   text: "Brings product and people together, shaping features that work in the real world.",
  //   icon: <InsightsIcon sx={{ fontSize: 22 }} />,
  //   accent: "rgba(92,181,179,0.16)",
  //   image: "/imgs/Team/James.png",
  //   linkedin: "https://www.linkedin.com/in/james-mbakwe-09b63066/",
  //   profileSummary: {
  //     whatTheyDo:
  //       "Works across product and users to help shape features that make sense in real-world use.",
  //     whatTheyBring:
  //       "Practical thinking, user insight, and a strong connection between feedback and product decisions.",
  //     timeAtCompany: "Joined the crew September 2025",
  //   },
  //   answers: {
  //     whatDoYouDo:
  //       "I help connect what users need with what we build, so the platform works well in day-to-day use.",
  //     weekendPlan: "Catching up with people, good food, and something active.",
  //     destination: "Greece",
  //     setsApart: "We build with real users in mind, not just feature lists.",
  //     hiddenTalent: "Remembering tiny bits of feedback from months ago.",
  //     loveAboutTeam:
  //       "The team is thoughtful, down-to-earth, and all-in on making the product better.",
  //     catOrDog: "Dog",
  //     earlyOrNight: "Early bird",
  //     coffee: "Latte",
  //     beachOrMountains: "Beach",
  //   },
  // },
];
const qaItems = [
  { key: "whatDoYouDo", label: "What do you do at 7DAY?" },
  { key: "weekendPlan", label: "Go-to weekend plan?" },
  { key: "destination", label: "Favourite travel destination?" },
  { key: "setsApart", label: "What do you think sets 7DAY apart?" },
  { key: "hiddenTalent", label: "Hidden talent?" },
  { key: "loveAboutTeam", label: "What do you love about the team?" },
  { key: "catOrDog", label: "Cat or dog?" },
  { key: "earlyOrNight", label: "Early bird or night owl?" },
  { key: "coffee", label: "Coffee order?" },
  { key: "beachOrMountains", label: "Beach or mountains?" },
];

const ProfileSummaryItem = ({ label, value }) => (
  <Box
    sx={{
      p: { xs: 1.5, md: 1.6 },
      borderRadius: 3,
      border: `1px solid ${alpha(appTheme.palette.green.main, 0.24)}`,
      backgroundColor: alpha(appTheme.palette.green.main, 0.08),
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    }}
  >
    <Typography
      sx={{
        fontFamily: appTheme.typography?.h1?.fontFamily,
        color: appTheme.palette.blue.main,
        fontWeight: 950,
        fontSize: { xs: 12, md: 12.5 },
        letterSpacing: ".05rem",
        textTransform: "uppercase",
        mb: 0.7,
        lineHeight: 1.2,
      }}
    >
      {label}
    </Typography>

    <Typography
      sx={{
        fontFamily: appTheme.typography?.body1?.fontFamily,
        color: appTheme.palette.gray.main,
        lineHeight: 1.7,
        fontSize: { xs: 13.5, md: 14 },
      }}
    >
      {value}
    </Typography>
  </Box>
);

const TeamModal = ({ member, open, onClose }) => {
  const isSmDown = useMediaQuery(useTheme().breakpoints.down("sm"));

  if (!member) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isSmDown}
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 5 },
          overflow: "hidden",
          background:
            "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(246,248,249,1) 100%)",
          boxShadow: "0 30px 80px rgba(20,55,74,0.18)",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            position: "relative",
            px: { xs: 2.25, md: 4 },
            pt: { xs: 2.25, md: 4 },
            pb: { xs: 3, md: 4 },
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              backgroundColor: "rgba(20,55,74,0.06)",
              color: appTheme.palette.blue.main,
              zIndex: 2,
              "&:hover": {
                backgroundColor: "rgba(20,55,74,0.12)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="start">
            <Grid item xs={12} md={4}>
              <Stack spacing={2.2} alignItems="center" textAlign="center">
                <Box
                  sx={{
                    p: "4px",
                    borderRadius: "50%",
                    background: `linear-gradient(135deg, ${appTheme.palette.green.main} 0%, ${alpha(
                      appTheme.palette.blue.main,
                      0.16,
                    )} 100%)`,
                  }}
                >
                  <Avatar
                    src={member.image}
                    alt={member.name}
                    sx={{
                      width: { xs: 130, md: 180 },
                      height: { xs: 130, md: 180 },
                      border: "4px solid white",
                    }}
                  />
                </Box>

                <Chip
                  label={member.role}
                  sx={{
                    fontFamily: appTheme.typography?.body1?.fontFamily,
                    fontWeight: 900,
                    letterSpacing: ".08rem",
                    borderRadius: 999,
                    backgroundColor: member.accent,
                    color: appTheme.palette.blue.main,
                    textTransform: "uppercase",
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: appTheme.typography?.h1?.fontFamily,
                    color: appTheme.palette.blue.main,
                    fontWeight: 950,
                    letterSpacing: ".03rem",
                    textTransform: "uppercase",
                    fontSize: { xs: 24, md: 30 },
                    lineHeight: 1.1,
                  }}
                >
                  {member.name}
                </Typography>

                <Typography
                  sx={{
                    maxWidth: 320,
                    fontFamily: appTheme.typography?.body1?.fontFamily,
                    color: appTheme.palette.gray.main,
                    lineHeight: 1.85,
                    fontSize: { xs: 14.5, md: 15.5 },
                  }}
                >
                  {member.text}
                </Typography>

                {member.linkedin && (
                  <IconButton
                    component="a"
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      width: 46,
                      height: 46,
                      borderRadius: 3,
                      backgroundColor: alpha(appTheme.palette.blue.main, 0.06),
                      color: appTheme.palette.blue.main,
                      "&:hover": {
                        backgroundColor: alpha(
                          appTheme.palette.blue.main,
                          0.12,
                        ),
                      },
                    }}
                  >
                    <LinkedInIcon />
                  </IconButton>
                )}
              </Stack>
            </Grid>

            <Grid item xs={12} md={8}>
              <Stack spacing={2}>
                <Box
                  sx={{
                    p: { xs: 1.8, md: 2.1 },
                    borderRadius: 4,
                    border: `1px solid ${alpha(appTheme.palette.green.main, 0.28)}`,
                    background:
                      "linear-gradient(180deg, rgba(92,181,179,0.14) 0%, rgba(255,255,255,0.98) 100%)",
                    boxShadow: "0 14px 34px rgba(20,55,74,0.06)",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: appTheme.typography?.h1?.fontFamily,
                      color: appTheme.palette.blue.main,
                      fontWeight: 950,
                      fontSize: { xs: 14, md: 14.5 },
                      letterSpacing: ".08rem",
                      textTransform: "uppercase",
                    }}
                  >
                    {member.profileSummary?.timeAtCompany}
                  </Typography>
                </Box>

                <Stack spacing={1.4}>
                  {qaItems.map((item) => (
                    <Box
                      key={item.key}
                      sx={{
                        p: { xs: 1.5, md: 1.8 },
                        borderRadius: 3,
                        border: `1px solid ${alpha(appTheme.palette.blue.main, 0.08)}`,
                        backgroundColor: "rgba(255,255,255,0.78)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: appTheme.typography?.h1?.fontFamily,
                          color: appTheme.palette.blue.main,
                          fontWeight: 900,
                          fontSize: { xs: 13, md: 13.5 },
                          letterSpacing: ".03rem",
                          textTransform: "uppercase",
                          mb: 0.7,
                        }}
                      >
                        {item.label}
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: appTheme.typography?.body1?.fontFamily,
                          color: appTheme.palette.gray.main,
                          lineHeight: 1.75,
                          fontSize: { xs: 14, md: 14.5 },
                        }}
                      >
                        {member.answers?.[item.key]}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
const TeamCard = ({ member, onOpenProfile }) => (
  <Card
    elevation={0}
    sx={{
      height: "100%",
      borderRadius: 4,
      border: `1px solid ${alpha(appTheme.palette.blue.main, 0.08)}`,
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(246,248,249,0.98) 100%)",
      boxShadow: "0 12px 34px rgba(20,55,74,0.05)",
      overflow: "hidden",
      transition:
        "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "0 24px 65px rgba(20,55,74,0.1)",
        borderColor: alpha(appTheme.palette.green.main, 0.3),
      },
    }}
  >
    <CardContent
      sx={{
        p: { xs: 2.25, md: 2.75 },
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1.5,
          mb: 2,
        }}
      >
        <Chip
          label={member.role}
          sx={{
            fontFamily: appTheme.typography?.body1?.fontFamily,
            fontWeight: 900,
            letterSpacing: ".08rem",
            borderRadius: 999,
            backgroundColor: member.accent,
            color: appTheme.palette.blue.main,
            textTransform: "uppercase",
            maxWidth: "calc(100% - 56px)",
            "& .MuiChip-label": {
              whiteSpace: "normal",
              display: "block",
              paddingTop: "6px",
              paddingBottom: "6px",
            },
          }}
        />

        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(20,55,74,0.06)",
            color: appTheme.palette.blue.main,
            flex: "0 0 auto",
          }}
        >
          {member.icon}
        </Box>
      </Box>

      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.1 }}>
        <Box
          sx={{
            borderRadius: "50%",
            p: "3px",
            background: `linear-gradient(135deg, ${alpha(
              appTheme.palette.green.main,
              0.8,
            )} 0%, ${alpha(appTheme.palette.blue.main, 0.22)} 100%)`,
          }}
        >
          <Avatar
            src={member.image}
            alt={member.name}
            sx={{
              width: 62,
              height: 62,
              border: "3px solid white",
            }}
          >
            {member.name.charAt(0)}
          </Avatar>
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: appTheme.typography?.h1?.fontFamily,
              color: appTheme.palette.blue.main,
              fontWeight: 950,
              letterSpacing: ".03rem",
              textTransform: "uppercase",
              fontSize: { xs: 16, md: 18 },
              lineHeight: 1.15,
            }}
          >
            {member.name}
          </Typography>

          <Typography
            sx={{
              mt: 0.35,
              fontFamily: appTheme.typography?.body1?.fontFamily,
              color: appTheme.palette.gray.main,
              fontSize: { xs: 13, md: 13.5 },
              lineHeight: 1.6,
            }}
          >
            {member.role}
          </Typography>
        </Box>
      </Stack>

      <Typography
        sx={{
          fontFamily: appTheme.typography?.body1?.fontFamily,
          color: appTheme.palette.gray.main,
          lineHeight: 1.85,
          fontSize: { xs: 13.5, md: 14.5 },
          mt: 1.2,
        }}
      >
        {member.text}
      </Typography>

      <Box sx={{ pt: 2 }}>
        <Button
          onClick={() => onOpenProfile(member)}
          endIcon={<ArrowOutwardIcon />}
          sx={{
            width: "100%",
            borderRadius: 3,
            py: 1.15,
            backgroundColor: appTheme.palette.blue.main,
            color: appTheme.palette.white.main,
            fontWeight: 900,
            letterSpacing: ".04rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: appTheme.palette.blue.main,
              opacity: 0.92,
            },
          }}
        >
          View profile
        </Button>
      </Box>
    </CardContent>
  </Card>
);

export const TeamContent = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const headingFont =
    appTheme.typography?.h1?.fontFamily ||
    appTheme.typography?.body1?.fontFamily;
  const bodyFont = appTheme.typography?.body1?.fontFamily;

  return (
    <>
      <Box
        sx={{
          position: "relative",
          backgroundColor: appTheme.palette.white.main,
          overflow: "hidden",
          py: { xs: 7, md: 10 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            background:
              "radial-gradient(900px 520px at 12% 0%, rgba(92,181,179,0.14) 0%, rgba(255,255,255,0) 60%), radial-gradient(900px 520px at 92% 12%, rgba(244,180,79,0.14) 0%, rgba(255,255,255,0) 58%)",
          }}
        />

        <Container maxWidth="lg" sx={{ position: "relative" }}>
          <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 980,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: headingFont,
                      fontWeight: 950,
                      letterSpacing: ".04rem",
                      textTransform: "uppercase",
                      color: appTheme.palette.blue.main,
                      fontSize: { xs: 28, sm: 34, md: 40 },
                      lineHeight: 1.08,
                      textAlign: "center",
                    }}
                  >
                    The people behind the platform.
                  </Typography>

                  <Typography
                    sx={{
                      mt: 2.4,
                      mx: "auto",
                      maxWidth: 900,
                      fontFamily: bodyFont,
                      color: appTheme.palette.gray.main,
                      lineHeight: 1.9,
                      fontSize: { xs: 15, md: 17 },
                      textAlign: "center",
                    }}
                  >
                    We’re software developers and product specialists creating
                    the tools organisations rely on to host with confidence —
                    from smart access and automation to real-time booking
                    experiences — all designed to make it effortless for guests.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: { xs: 5, md: 6.5 } }}>
            <Grid container spacing={2.6} alignItems="stretch">
              {team.map((member) => (
                <Grid item xs={12} sm={6} md={4} key={member.name}>
                  <TeamCard member={member} onOpenProfile={setSelectedMember} />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      <TeamModal
        member={selectedMember}
        open={Boolean(selectedMember)}
        onClose={() => setSelectedMember(null)}
      />
    </>
  );
};
